import { useConvexAuth, useMutation } from "convex/react";
import { useEffect, useRef } from "react";
import { api } from "../../../convex/_generated/api";
import { isConvexConfigured } from "@/lib/convex";
import { getUnlockToken, rememberSubscribedEmail, rememberUnlockToken } from "./mailingStorage";

export function useViewerUnlock(): void {
  const { isAuthenticated } = useConvexAuth();
  const claim = useMutation(api.mailingList.claimUnlockForViewer);
  const claimedRef = useRef(false);

  useEffect(() => {
    if (!isConvexConfigured || !isAuthenticated || claimedRef.current) return;
    if (getUnlockToken()) return;
    claimedRef.current = true;
    void claim({})
      .then((result) => {
        if (!result.unlocked || !result.email || !result.unlockToken) return;
        rememberSubscribedEmail(result.email);
        rememberUnlockToken(result.unlockToken);
      })
      .catch(() => {
        claimedRef.current = false;
      });
  }, [claim, isAuthenticated]);
}
